import styled from 'styled-components'
import { theme } from '@dasa-health/components-react'

export const ButtonStyles = styled.button`
    position: fixed;
    bottom: 16px;
    right: 16px;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background-color: #002199;
    cursor: pointer;

    @media (min-width: ${theme.breakpoints[2]}) {
        :hover div {
            opacity: 1;
            visibility: visible;
        }
    }

    @media (min-width: ${theme.breakpoints[3]}) {
        bottom: 32px;
        right: 32px;
    }
`

export const TooltipContainer = styled.div`
    position: relative;
    display: inline-block;

    border-bottom: 1px dotted black;
`

export const TooltipText = styled.div`
    visibility: hidden;
    width: 207px;
    height: 32px;
    background-color: #161616;
    color: #fff;
    text-align: center;
    border-radius: 6px;

    position: absolute;
    z-index: 1;
    bottom: -4px;
    right: 46px;

    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0.5;
    transition: opacity 0.2s;

    ::after {
        content: '';
        position: absolute;
        top: 50%;
        left: 100%;
        margin-top: -5px;
        border-width: 5px;
        border-style: solid;
        border-color: transparent transparent transparent black;
    }
`
